import {
  ComponentParams,
  ComponentRendering,
  Field,
  ImageField,
  LinkField,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  ImagePropertiesParams,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export interface C13SidePhotoContentCardProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & C13SidePhotoContentCardParams;
  fields?: C13SidePhotoContentCardFields;
}

export type C13SidePhotoContentCardParams = {
  TitleType?: string;
  Layout?: string;
  ImageSide?: string;
  SecondaryCtaStyle?: string;
} & AnchorTargetParams &
  TranslationOptionsParams &
  ImagePropertiesParams;

export interface C13SidePhotoContentCardFields {
  Image?: ImageField;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  PrimaryCtaButton?: LinkField;
  SecondaryCtaButton?: LinkField;
  PrimaryLink?: LinkField;
  SecondaryLink?: LinkField;
}
